import { Configuration } from "@azure/msal-browser";

// Microsoft Azure AD configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID || "YOUR_MICROSOFT_CLIENT_ID",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
};

// Google OAuth configuration
export const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || "346797190082-8f0pf46m0qb0cpnh10v12iumfu8ks0o1.apps.googleusercontent.com";
